/**
 * IMPORTS
 */
import { ApiService } from "@/data/http/axios/axios-interceptors";

const axioApi = ApiService.getInstance().client;

async function axiosClient<T>(
  url: string,
  options?: {
    method?: "get" | "post" | "put" | "patch" | "delete";
    data?: unknown;
    params?: unknown;
    headers?: Record<string, string>;
  }
): Promise<T> {
  const response = await axioApi.request<T>({
    url,
    method: options?.method ?? "get",
    data: options?.data,
    params: options?.params,
    headers: options?.headers,
  });

  return response.data;
}

/**
 * EXPORTS
 */
export { axiosClient };
